export const TKeyClientAvatar = {
  CLIENT_AVATAR_NAV: "CLIENT_AVATAR_NAV",
  CLIENT_AVATAR_SELECT_OFFER: "CLIENT_AVATAR_SELECT_OFFER",
  CLIENT_AVATAR_SEO_TITLE: "CLIENT_AVATAR_SEO_TITLE",
  CLIENT_AVATAR_TITLE: "CLIENT_AVATAR_TITLE",
  CLIENT_AVATAR_SUBTITLE: "CLIENT_AVATAR_SUBTITLE",
  CLIENT_AVATAR_NOT_GENERATED_MEMBER: "CLIENT_AVATAR_NOT_GENERATED_MEMBER",
  CLIENT_AVATAR_CTA_CARD_TITLE: "CLIENT_AVATAR_CTA_CARD_TITLE",
  CLIENT_AVATAR_CTA_CARD_DESCRIPTION: "CLIENT_AVATAR_CTA_CARD_DESCRIPTION",
  CLIENT_AVATAR_CTA_CARD_DESCRIPTION_MEMBER: "CLIENT_AVATAR_CTA_CARD_DESCRIPTION_MEMBER",
  CLIENT_AVATAR_CTA_CARD_CTA: "CLIENT_AVATAR_CTA_CARD_CTA",
  CLIENT_AVATAR_EXTRACT_TITLE: "CLIENT_AVATAR_EXTRACT_TITLE",
  CLIENT_AVATAR_EXTRACT_BADGE: "CLIENT_AVATAR_EXTRACT_BADGE",
  CLIENT_AVATAR_EXTRACT_DESCRIPTION: "CLIENT_AVATAR_EXTRACT_DESCRIPTION",
  CLIENT_AVATAR_EXTRACT_BENEFIT_1: "CLIENT_AVATAR_EXTRACT_BENEFIT_1",
  CLIENT_AVATAR_EXTRACT_BENEFIT_2: "CLIENT_AVATAR_EXTRACT_BENEFIT_2",
  CLIENT_AVATAR_EXTRACT_BENEFIT_3: "CLIENT_AVATAR_EXTRACT_BENEFIT_3",
  CLIENT_AVATAR_EXTRACT_BUTTON: "CLIENT_AVATAR_EXTRACT_BUTTON",
  CLIENT_AVATAR_ENRICH_BUTTON: "CLIENT_AVATAR_ENRICH_BUTTON",
  CLIENT_AVATAR_REEXTRACT_BUTTON: "CLIENT_AVATAR_REEXTRACT_BUTTON",
  CLIENT_AVATAR_REEXTRACT_TITLE: "CLIENT_AVATAR_REEXTRACT_TITLE",
  CLIENT_AVATAR_REEXTRACT_DESC: "CLIENT_AVATAR_REEXTRACT_DESC",
  CLIENT_AVATAR_ENRICH_DESC: "CLIENT_AVATAR_ENRICH_DESC",
  CLIENT_AVATAR_CALLS_REMOVED_NOTE: "CLIENT_AVATAR_CALLS_REMOVED_NOTE",
  CLIENT_AVATAR_EXPORT_BUTTON: "CLIENT_AVATAR_EXPORT_BUTTON",
  CLIENT_AVATAR_EXTRACT_COST: "CLIENT_AVATAR_EXTRACT_COST",
  CLIENT_AVATAR_EXTRACT_NO_CALLS: "CLIENT_AVATAR_EXTRACT_NO_CALLS",
  CLIENT_AVATAR_EXTRACT_NO_CALLS_LINK: "CLIENT_AVATAR_EXTRACT_NO_CALLS_LINK",
  CLIENT_AVATAR_EXTRACT_STEP_1: "CLIENT_AVATAR_EXTRACT_STEP_1",
  CLIENT_AVATAR_EXTRACT_STEP_2: "CLIENT_AVATAR_EXTRACT_STEP_2",
  CLIENT_AVATAR_EXTRACT_STEP_3: "CLIENT_AVATAR_EXTRACT_STEP_3",
  CLIENT_AVATAR_GENERATE_TITLE: "CLIENT_AVATAR_GENERATE_TITLE",
  CLIENT_AVATAR_GENERATE_BADGE: "CLIENT_AVATAR_GENERATE_BADGE",
  CLIENT_AVATAR_GENERATE_DESCRIPTION: "CLIENT_AVATAR_GENERATE_DESCRIPTION",
  CLIENT_AVATAR_GENERATE_BENEFIT_1: "CLIENT_AVATAR_GENERATE_BENEFIT_1",
  CLIENT_AVATAR_GENERATE_BENEFIT_2: "CLIENT_AVATAR_GENERATE_BENEFIT_2",
  CLIENT_AVATAR_GENERATE_BENEFIT_3: "CLIENT_AVATAR_GENERATE_BENEFIT_3",
  CLIENT_AVATAR_GENERATE_CTA: "CLIENT_AVATAR_GENERATE_CTA",
  CLIENT_AVATAR_OFFER_TYPE_LABEL: "CLIENT_AVATAR_OFFER_TYPE_LABEL",
  CLIENT_AVATAR_ANALYZING: "CLIENT_AVATAR_ANALYZING",
  CLIENT_AVATAR_EXPORT_TITLE: "CLIENT_AVATAR_EXPORT_TITLE",
  CLIENT_AVATAR_EXPORT_ONE_TITLE: "CLIENT_AVATAR_EXPORT_ONE_TITLE",
  CLIENT_AVATAR_EXPORT_SUBMIT: "CLIENT_AVATAR_EXPORT_SUBMIT",
  CLIENT_AVATAR_EXPORT_FORMAT: "CLIENT_AVATAR_EXPORT_FORMAT",
  CLIENT_AVATAR_EXPORT_TYPES: "CLIENT_AVATAR_EXPORT_TYPES",
  CLIENT_AVATAR_EXPORT_GENERATED_BY: "CLIENT_AVATAR_EXPORT_GENERATED_BY",
  CLIENT_AVATAR_NA: "CLIENT_AVATAR_NA",
  CLIENT_AVATAR_CREATE_BUTTON: "CLIENT_AVATAR_CREATE_BUTTON",
  CLIENT_AVATAR_TYPE_PRIMARY: "CLIENT_AVATAR_TYPE_PRIMARY",
  CLIENT_AVATAR_TYPE_SECONDARY: "CLIENT_AVATAR_TYPE_SECONDARY",
  CLIENT_AVATAR_TYPE_EXPLORATORY: "CLIENT_AVATAR_TYPE_EXPLORATORY",
  CLIENT_AVATAR_NO_OFFER_TITLE: "CLIENT_AVATAR_NO_OFFER_TITLE",
  CLIENT_AVATAR_NO_OFFER_BADGE: "CLIENT_AVATAR_NO_OFFER_BADGE",
  CLIENT_AVATAR_NO_OFFER_DESCRIPTION: "CLIENT_AVATAR_NO_OFFER_DESCRIPTION",
  CLIENT_AVATAR_NO_OFFER_CREATE_BUTTON: "CLIENT_AVATAR_NO_OFFER_CREATE_BUTTON",
  CLIENT_AVATAR_DETAIL_TAB_ABOUT: "CLIENT_AVATAR_DETAIL_TAB_ABOUT",
  CLIENT_AVATAR_DETAIL_TAB_PAIN: "CLIENT_AVATAR_DETAIL_TAB_PAIN",
  CLIENT_AVATAR_DETAIL_TAB_SITUATION: "CLIENT_AVATAR_DETAIL_TAB_SITUATION",
  CLIENT_AVATAR_DETAIL_TAB_OBJECTIONS: "CLIENT_AVATAR_DETAIL_TAB_OBJECTIONS",
  CLIENT_AVATAR_DETAIL_TAB_VERBATIMS: "CLIENT_AVATAR_DETAIL_TAB_VERBATIMS",
  CLIENT_AVATAR_DETAIL_TAB_FIT: "CLIENT_AVATAR_DETAIL_TAB_FIT",
  AVATAR_DATA_SOURCE_MANUAL: "AVATAR_DATA_SOURCE_MANUAL",
  AVATAR_DATA_SOURCE_AI: "AVATAR_DATA_SOURCE_AI",
  AVATAR_DATA_SOURCE_CALLS: "AVATAR_DATA_SOURCE_CALLS",
  AVATAR_DATA_SOURCE_COMMUNITIES: "AVATAR_DATA_SOURCE_COMMUNITIES",
  AVATAR_DATA_SOURCE_SURVEYS: "AVATAR_DATA_SOURCE_SURVEYS",
  AVATAR_DATA_SOURCE_SUPPORT: "AVATAR_DATA_SOURCE_SUPPORT",
  AVATAR_DATA_SOURCE_COMPETITORS: "AVATAR_DATA_SOURCE_COMPETITORS",
  AVATAR_DATA_SOURCE_OTHER: "AVATAR_DATA_SOURCE_OTHER",
  CLIENT_AVATAR_DETAIL_ABOUT_SUMMARY_TITLE: "CLIENT_AVATAR_DETAIL_ABOUT_SUMMARY_TITLE",
  CLIENT_AVATAR_DETAIL_ABOUT_SUMMARY_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_SUMMARY_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_AGE: "CLIENT_AVATAR_DETAIL_ABOUT_AGE",
  CLIENT_AVATAR_DETAIL_ABOUT_AGE_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_AGE_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_INCOME: "CLIENT_AVATAR_DETAIL_ABOUT_INCOME",
  CLIENT_AVATAR_DETAIL_ABOUT_INCOME_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_INCOME_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_GENDER: "CLIENT_AVATAR_DETAIL_ABOUT_GENDER",
  CLIENT_AVATAR_DETAIL_ABOUT_GENDER_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_GENDER_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_LOCATION: "CLIENT_AVATAR_DETAIL_ABOUT_LOCATION",
  CLIENT_AVATAR_DETAIL_ABOUT_LOCATION_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_ABOUT_LOCATION_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_CARD_INPUT_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_ABOUT_CARD_INPUT_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_PAIN_DESIRES: "CLIENT_AVATAR_DETAIL_PAIN_DESIRES",
  CLIENT_AVATAR_DETAIL_PAIN_FRUSTRATIONS: "CLIENT_AVATAR_DETAIL_PAIN_FRUSTRATIONS",
  CLIENT_AVATAR_DETAIL_PAIN_DREAMS: "CLIENT_AVATAR_DETAIL_PAIN_DREAMS",
  CLIENT_AVATAR_DETAIL_PAIN_FEARS: "CLIENT_AVATAR_DETAIL_PAIN_FEARS",
  CLIENT_AVATAR_DETAIL_PAIN_COST_TODAY: "CLIENT_AVATAR_DETAIL_PAIN_COST_TODAY",
  CLIENT_AVATAR_DETAIL_PAIN_COST_TIME: "CLIENT_AVATAR_DETAIL_PAIN_COST_TIME",
  CLIENT_AVATAR_DETAIL_PAIN_COST_TIME_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_PAIN_COST_TIME_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_PAIN_COST_ENERGY: "CLIENT_AVATAR_DETAIL_PAIN_COST_ENERGY",
  CLIENT_AVATAR_DETAIL_PAIN_COST_ENERGY_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_PAIN_COST_ENERGY_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_PAIN_COST_OPPORTUNITY: "CLIENT_AVATAR_DETAIL_PAIN_COST_OPPORTUNITY",
  CLIENT_AVATAR_DETAIL_PAIN_COST_OPPORTUNITY_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_PAIN_COST_OPPORTUNITY_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_SITUATION_CURRENT: "CLIENT_AVATAR_DETAIL_SITUATION_CURRENT",
  CLIENT_AVATAR_DETAIL_SITUATION_DESIRED: "CLIENT_AVATAR_DETAIL_SITUATION_DESIRED",
  CLIENT_AVATAR_DETAIL_SITUATION_ROUTINE: "CLIENT_AVATAR_DETAIL_SITUATION_ROUTINE",
  CLIENT_AVATAR_DETAIL_SITUATION_MINDSET: "CLIENT_AVATAR_DETAIL_SITUATION_MINDSET",
  CLIENT_AVATAR_DETAIL_SITUATION_MINDSET_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_SITUATION_MINDSET_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_SITUATION_BLOCKERS: "CLIENT_AVATAR_DETAIL_SITUATION_BLOCKERS",
  CLIENT_AVATAR_DETAIL_OBJECTIONS_BELIEFS: "CLIENT_AVATAR_DETAIL_OBJECTIONS_BELIEFS",
  CLIENT_AVATAR_DETAIL_OBJECTIONS_PURCHASE: "CLIENT_AVATAR_DETAIL_OBJECTIONS_PURCHASE",
  CLIENT_AVATAR_DETAIL_OBJECTIONS_HANDLER: "CLIENT_AVATAR_DETAIL_OBJECTIONS_HANDLER",
  CLIENT_AVATAR_DETAIL_VERBATIMS_PRIVATE: "CLIENT_AVATAR_DETAIL_VERBATIMS_PRIVATE",
  CLIENT_AVATAR_DETAIL_VERBATIMS_PUBLIC: "CLIENT_AVATAR_DETAIL_VERBATIMS_PUBLIC",
  CLIENT_AVATAR_DETAIL_VERBATIMS_KEYWORDS: "CLIENT_AVATAR_DETAIL_VERBATIMS_KEYWORDS",
  CLIENT_AVATAR_DETAIL_VERBATIMS_EMOTIONAL: "CLIENT_AVATAR_DETAIL_VERBATIMS_EMOTIONAL",
  CLIENT_AVATAR_DETAIL_VERBATIMS_COPY_ADVICE: "CLIENT_AVATAR_DETAIL_VERBATIMS_COPY_ADVICE",
  CLIENT_AVATAR_DETAIL_VERBATIMS_COPY_ADVICE_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_VERBATIMS_COPY_ADVICE_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_FIT_TITLE: "CLIENT_AVATAR_DETAIL_FIT_TITLE",
  CLIENT_AVATAR_DETAIL_FIT_URGENCY: "CLIENT_AVATAR_DETAIL_FIT_URGENCY",
  CLIENT_AVATAR_DETAIL_FIT_URGENCY_HIGH: "CLIENT_AVATAR_DETAIL_FIT_URGENCY_HIGH",
  CLIENT_AVATAR_DETAIL_FIT_URGENCY_MEDIUM: "CLIENT_AVATAR_DETAIL_FIT_URGENCY_MEDIUM",
  CLIENT_AVATAR_DETAIL_FIT_URGENCY_LOW: "CLIENT_AVATAR_DETAIL_FIT_URGENCY_LOW",
  CLIENT_AVATAR_DETAIL_FIT_URGENCY_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_FIT_URGENCY_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_FIT_PURCHASE_POTENTIAL: "CLIENT_AVATAR_DETAIL_FIT_PURCHASE_POTENTIAL",
  CLIENT_AVATAR_DETAIL_FIT_PURCHASE_POTENTIAL_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_FIT_PURCHASE_POTENTIAL_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_FIT_IDEAL_IF: "CLIENT_AVATAR_DETAIL_FIT_IDEAL_IF",
  CLIENT_AVATAR_DETAIL_FIT_NON_IDEAL_IF: "CLIENT_AVATAR_DETAIL_FIT_NON_IDEAL_IF",
  CLIENT_AVATAR_DETAIL_FIT_TRIGGERS: "CLIENT_AVATAR_DETAIL_FIT_TRIGGERS",
  CLIENT_AVATAR_DETAIL_FIT_WHERE_TO_FIND: "CLIENT_AVATAR_DETAIL_FIT_WHERE_TO_FIND",
  CLIENT_AVATAR_DETAIL_FIT_VOICE_OF_TRUST: "CLIENT_AVATAR_DETAIL_FIT_VOICE_OF_TRUST",
  CLIENT_AVATAR_DETAIL_FIT_VOICE_OF_TRUST_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_FIT_VOICE_OF_TRUST_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_FIT_APPROACH_ANGLE: "CLIENT_AVATAR_DETAIL_FIT_APPROACH_ANGLE",
  CLIENT_AVATAR_DETAIL_FIT_APPROACH_ANGLE_PLACEHOLDER:
    "CLIENT_AVATAR_DETAIL_FIT_APPROACH_ANGLE_PLACEHOLDER",
  CLIENT_AVATAR_CARD_NAME_PLACEHOLDER: "CLIENT_AVATAR_CARD_NAME_PLACEHOLDER",
  CLIENT_AVATAR_CARD_ROLE_PLACEHOLDER: "CLIENT_AVATAR_CARD_ROLE_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_SCORE_TITLE: "CLIENT_AVATAR_DETAIL_SCORE_TITLE",
  CLIENT_AVATAR_DETAIL_ABOUT_ROLE: "CLIENT_AVATAR_DETAIL_ABOUT_ROLE",
  CLIENT_AVATAR_DETAIL_ABOUT_ROLE_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_ROLE_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_MARKET: "CLIENT_AVATAR_DETAIL_ABOUT_MARKET",
  CLIENT_AVATAR_DETAIL_ABOUT_MARKET_PLACEHOLDER: "CLIENT_AVATAR_DETAIL_ABOUT_MARKET_PLACEHOLDER",
  CLIENT_AVATAR_DETAIL_ABOUT_PRIORITY_TITLE: "CLIENT_AVATAR_DETAIL_ABOUT_PRIORITY_TITLE",
  CLIENT_AVATAR_DETAIL_ABOUT_PRIORITY_PLACEHOLDER_TEXT:
    "CLIENT_AVATAR_DETAIL_ABOUT_PRIORITY_PLACEHOLDER_TEXT",
  CLIENT_AVATAR_DETAIL_ABOUT_SOURCES_TITLE: "CLIENT_AVATAR_DETAIL_ABOUT_SOURCES_TITLE",
  AVATAR_UPDATE_ERROR: "AVATAR_UPDATE_ERROR",
  AVATAR_EXPORT_ERROR: "AVATAR_EXPORT_ERROR",
  CLIENT_AVATAR_DETAIL_SCORE_INFO: "CLIENT_AVATAR_DETAIL_SCORE_INFO",
  CLIENT_AVATAR_EXTRACTION_AVATARS_FRESH: "CLIENT_AVATAR_EXTRACTION_AVATARS_FRESH",
  CLIENT_AVATAR_EXTRACTION_AVATARS_STALE: "CLIENT_AVATAR_EXTRACTION_AVATARS_STALE",
  CLIENT_AVATAR_EXTRACTION_CHANGED_OFFER: "CLIENT_AVATAR_EXTRACTION_CHANGED_OFFER",
  CLIENT_AVATAR_EXTRACTION_CHANGED_INSIGHTS: "CLIENT_AVATAR_EXTRACTION_CHANGED_INSIGHTS",
  CLIENT_AVATAR_FRESHNESS_FRESH: "CLIENT_AVATAR_FRESHNESS_FRESH",
  CLIENT_AVATAR_FRESHNESS_STALE: "CLIENT_AVATAR_FRESHNESS_STALE",
  CLIENT_AVATAR_DETAIL_SCORE_CONFIDENCE: "CLIENT_AVATAR_DETAIL_SCORE_CONFIDENCE",
  CLIENT_AVATAR_DETAIL_SCORE_PAIN: "CLIENT_AVATAR_DETAIL_SCORE_PAIN",
  CLIENT_AVATAR_MODAL_CREATE_TITLE: "CLIENT_AVATAR_MODAL_CREATE_TITLE",
  CLIENT_AVATAR_MODAL_DETAIL_TITLE: "CLIENT_AVATAR_MODAL_DETAIL_TITLE",
} as const;
